import { Pill } from 'components/Pill/Pill'
import cx from 'classnames'
import Styles from 'screens/Schedule/ScheduleStatusBanner/Banners/ScheduleStatusBanner.module.scss'
import { StatusPillProps } from 'screens/Schedule/ScheduleStatusBanner/Types'

export const StatusPill = ({ status, children, isWarning, size = 'md' }: StatusPillProps) => {
  return (
    <Pill
      className={cx(Styles.pill, Styles[status], {
        [Styles.warning]: isWarning,
      })}
      size={size}
    >
      {children}
    </Pill>
  )
}
